/* unplugin-vue-components disabled */import script from "./NotificationItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationItem.vue?vue&type=script&lang=ts&setup=true"

import "./NotificationItem.vue?vue&type=style&index=0&id=66e8c72a&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66e8c72a"]])

export default __exports__